function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 12.5,
  cy: 12.5,
  r: 12.5,
  transform: "rotate(-90 12.5 12.5)",
  fill: "#F7F7F7"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M15.7135 13.3193L12.3297 16.2501C12.0188 16.5914 11.4841 16.5817 11.1854 16.2294C10.9318 15.9303 10.9392 15.4861 11.2025 15.1958L14.3622 12.5L11.2025 9.80419C10.9392 9.51393 10.9318 9.06967 11.1854 8.7706C11.4841 8.41825 12.0188 8.40858 12.3297 8.7499L15.7135 11.6807C15.7135 11.6807 16 12.0158 16 12.5C16 12.9842 15.7135 13.3193 15.7135 13.3193Z",
  fill: "#767B87"
});

const SvgCollapseMoreIcon = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgCollapseMoreIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/CollapseMoreIcon.570befe8.svg";
export { ForwardRef as ReactComponent };